import React from "react";
import styles from "../consents.module.scss.js";
const ImplicitConsent = ({ document }) => {
  if (!document) {
    return null;
  }
  const {
    document: { documentTitle, documentText1 }
  } = document;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, documentTitle && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: `gl-vspace-bpall-small gl-label gl-label--bold gl-label--small ${styles.implicit}`,
      "data-auto-id": "implicit-consents-title"
    },
    documentTitle
  ), /* @__PURE__ */ React.createElement(
    "span",
    {
      dangerouslySetInnerHTML: { __html: documentText1 },
      className: `gl-body--s gl-vspace ${styles.implicit} ${styles.legalText}`,
      "data-auto-id": "implicit-consents-body"
    }
  ));
};
export {
  ImplicitConsent as default
};
//# sourceMappingURL=implicit-consent.js.map
